<script lang="ts">
    import { Accordion, AccordionItem } from "sveltestrap";
    import type { Diligence } from "../../../Model/Diligence";
    import AllListDataComplainants from "../../AllListDataComplainants.svelte";
    import type { Third } from "../../../Model/Third";
    import AddThirdModal from "../../AddThirdModal.svelte";
    import DiligenceWitnessData from "../Global/DiligenceWitnessData.svelte";
    import PoliceManifestationFinishForm from "../Global/PoliceManifestationFinishForm.svelte";
    import { complainantGeneralService, complainantService, denouncedGeneralService, denouncedService, legalGuardianService, subtypesDiligencesService, witnessService } from "../../../services";
    import DiligenceComplainantGeneralData from "./Data/DiligenceComplainantGeneralData.svelte";
    import DiligenceDenouncedGeneralData from "./Data/DiligenceDenouncedGeneralData.svelte";
    import FilesList from "../../FilesList.svelte";
    import PoliceManifestationInitialForm from "../Global/PoliceManifestationInitialForm.svelte";
    import PoliceManifestationGeneralData from "./Data/PoliceManifestationGeneralData.svelte";
    import type { SubtypesDiligences } from "../../../Model/SubtypesDiligences";
    import DiligenceLegalGuardianData from "../Global/DiligenceLegalGuardianData.svelte";

    export let diligence: Diligence;

    type ThirdType = 'complainant' | 'denounced' | 'witness' | 'legalGuardian';

    let complainantsThirds: Third[] = [];
    let complainantThird: Third;
    let complainantThirdId: string = '';

    let denouncedsThirds: Third[] = [];
    let denouncedThird: Third;
    let denouncedThirdId: string = '';

    let witnesssThirds: Third[] = [];
    let witnessThird: Third;
    let witnessThirdId: string = '';

    let legalGuardianThirds: Third[] = [];
    let legalGuardianThird: Third;
    let legalGuardianThirdId: string = '';

    let openModal = false;
    let openComplainantModal = false;
    let openDenouncedModal = false;
    let openWitnessModal = false;
    let openLegalGuardianModal = false;

    let subtype: SubtypesDiligences = null;


    let onChangeThird: (event: CustomEvent<Third>) => Promise<void> = async () => {};

    $: loadForm(diligence);

    async function loadForm(diligence){
        subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);
        await Promise.all([ 
            loadComplainats(diligence),
            loadDenounceds(diligence),
            loadWitness(diligence),
            loadLegalGuardians(diligence)
        ]) 
    }

async function loadComplainats(diligence){
    let opts = {
        offset : 0,
        limit : 25,
        filters: {
            diligenceId: diligence.id,
        }
    }

    complainantsThirds = await complainantGeneralService.findThirds(opts);
    complainantsThirds.sort((a,b) => {
        return a.name < b.name ? -1 : 1;
    })
  }

    async function saveNewComplainantGeneral({ detail: third }: CustomEvent<Third>){
        await complainantService.createComplainant(third.id, diligence.id);
        await complainantGeneralService.createComplainantGeneral(third.id, diligence.id);
        complainantsThirds.push(third);
        complainantsThirds = complainantsThirds;
    }

    async function openComplaintModal({detail}: CustomEvent<Third>){
        complainantThird = complainantsThirds.find(c => c.id == detail.id)
        if (complainantThird) {
            complainantThirdId = detail.id
            openComplainantModal = true
        }
    }

    async function loadDenounceds(diligence){
        let opts = {
            offset : 0,
            limit : 25,
            filters: {
                diligenceId: diligence.id,
            }
        }

        denouncedsThirds = await denouncedGeneralService.findThirds(opts);
        denouncedsThirds.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
    }

    async function saveNewDenouncedGeneral({ detail: third }: CustomEvent<Third>){
        await denouncedService.createDenounced(third.id, diligence.id);
        await denouncedGeneralService.createDenouncedGeneral(third.id, diligence.id);
        denouncedsThirds.push(third);
        denouncedsThirds = denouncedsThirds;
    }

    async function openActionDenouncedModal({detail}: CustomEvent<Third>){
        denouncedThird = denouncedsThirds.find(c => c.id == detail.id)
        if (denouncedThird) {
            denouncedThirdId = detail.id
            openDenouncedModal = true
        }
    }


    async function loadWitness(diligence){
    
        let opts = {
            offset : 0,
            limit : 100,
            filters: {
                diligenceId: diligence.id,
            }
        }

        witnesssThirds = await witnessService.findThirds(opts);
        witnesssThirds.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
    }

    async function saveNewWitnessGeneral({ detail: third }: CustomEvent<Third>){
            await witnessService.createWitness(third.id, diligence.id);
            witnesssThirds.push(third);
            witnesssThirds = witnesssThirds;
    }


    async function openActionWitnessModal({detail}: CustomEvent<Third>){
        witnessThird = witnesssThirds.find(c => c.id == detail.id)
        if (witnessThird) {
            witnessThirdId = detail.id
            openWitnessModal = true
        }
    }

    async function loadLegalGuardians(diligence) {
        let opts = {
            offset : 0,
            limit : 100,
            filters: {
                diligenceId: diligence.id,
            }
        }

        legalGuardianThirds = await legalGuardianService.findThirds(opts);
        legalGuardianThirds.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
    }

    async function saveNewLegalGuardianGeneral({ detail: third }: CustomEvent<Third>){
            await legalGuardianService.createLegalGuardian(third.id, diligence.id);
            legalGuardianThirds.push(third);
            legalGuardianThirds = legalGuardianThirds;
    }

    async function openActionLegalGuardianModal({detail}: CustomEvent<Third>){
        legalGuardianThird = legalGuardianThirds.find(c => c.id == detail.id)
        if (legalGuardianThird) {
            legalGuardianThirdId = detail.id
            openLegalGuardianModal = true
        }
    }

    async function onAddNewThird(type: ThirdType){
        switch (type) {
            case 'complainant':
                onChangeThird = saveNewComplainantGeneral;
            break;
            case 'denounced':
                onChangeThird = saveNewDenouncedGeneral;
            break;
            case 'witness':
                onChangeThird = saveNewWitnessGeneral;
            break;
            case 'legalGuardian':
                onChangeThird = saveNewLegalGuardianGeneral;
            break;
            default:
                throw new Error(`Error al obtener el type a guardar`);
        }

        openModal = true
    }

    function toggle() {
        openModal = !openModal;
    }
    function toggleComplainantModal(){
        openComplainantModal = !openComplainantModal
    }

    function toggleDenouncedModal(){
        openDenouncedModal = !openDenouncedModal
    }

    function toggleWitnessModal(){
        openWitnessModal = !openWitnessModal
    }

    function toggleLegalGuardianModal(){
        openLegalGuardianModal = !openLegalGuardianModal
    }

    function saveComplainant(){
        loadForm(diligence);
    }

    async function deleteComplaiant(event) {
    await complainantGeneralService.deleteComplainantGeneral(event.detail);

    await complainantService.deleteComplainantGlobal(event.detail);

    loadComplainats(diligence)
  }

  async function deleteDenounced(event) {
    await denouncedGeneralService.deleteDenouncedGeneral(event.detail);

    await denouncedService.deleteDenouncedGlobal(event.detail);

    loadDenounceds(diligence)
  }

  async function deleteWitness(event) {
    await witnessService.deleteWitness(event.detail);

    loadWitness(diligence)
  }

  async function deleteLegalGuardian(event) {
    await legalGuardianService.deleteLegalGuardian(event.detail);

    loadLegalGuardians(diligence)
  }

</script>

<Accordion>
    <AccordionItem header="Manifestación Policial Inicial">
        <PoliceManifestationInitialForm {diligence} />
    </AccordionItem>
    <AccordionItem header="Denunciante">
        <AllListDataComplainants thirds={complainantsThirds} on:editThird={openComplaintModal} on:newThird={() => onAddNewThird('complainant')} on:deleteComplainant={deleteComplaiant}/>
    </AccordionItem>
    <AccordionItem header="Denunciado">
        <AllListDataComplainants thirds={denouncedsThirds} on:editThird={openActionDenouncedModal} on:newThird={() => onAddNewThird('denounced')} on:deleteComplainant={deleteDenounced}/>
    </AccordionItem>
    <AccordionItem header="Testigos">
        <AllListDataComplainants thirds={witnesssThirds} on:editThird={openActionWitnessModal} on:newThird={() => onAddNewThird('witness')} on:deleteComplainant={deleteWitness}/>
    </AccordionItem>
    {#if subtype && subtype.subTypeDiligence === 'AUTORIZACION PARA VIAJAR'}
        <AccordionItem header="Representante Legal">
            <AllListDataComplainants thirds={legalGuardianThirds} on:editThird={openActionLegalGuardianModal} on:newThird={() => onAddNewThird('legalGuardian')} on:deleteComplainant={deleteLegalGuardian}/>
        </AccordionItem>
    {/if}
    <AccordionItem header="Manifestación Policial Final">
        <PoliceManifestationGeneralData diligence={diligence} />
    </AccordionItem>
    <AccordionItem header="Archivos">
        <FilesList contextId={diligence.id}/>
    </AccordionItem>
</Accordion>

<AddThirdModal
    open={openModal}
    {toggle}
    thirdId={complainantThirdId}
    on:changeThird={onChangeThird}
/>

<DiligenceComplainantGeneralData
    open={openComplainantModal}
    toggle={toggleComplainantModal}
    complainantThird={complainantThird} 
    diligenceId={diligence.id} 
    on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceDenouncedGeneralData
    open={openDenouncedModal}
    toggle={toggleDenouncedModal}
    denouncedThird={denouncedThird} 
    diligenceId={diligence.id} 
    on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceWitnessData
    open={openWitnessModal}
    toggle={toggleWitnessModal}
    witnessThird={witnessThird} 
    diligenceId={diligence.id} 
    on:saveWitness={(event) => saveComplainant()}
/>

<!-- svelte-ignore missing-declaration -->
<DiligenceLegalGuardianData
    open={openLegalGuardianModal}
    toggle={toggleLegalGuardianModal}
    legalGuardianThird={legalGuardianThird} 
    diligenceId={diligence.id} 
    on:saveLegalGuardian={(event) => saveComplainant()}
/>

<style lang="scss">

    :global(.accordion){
        padding-right: 3px !important;
        padding-left: 3px !important;
    }
  
    :global(.accordion-item){
        border: 1px solid #dee2e6 !important;
        border-radius: 0.25rem !important;
    }
  
  
</style>